import { DocumentationList } from "./DocumentationList/DocumentationList";

export const Documentation = () => {
    return <DocumentationList />;
};

export default Documentation;
